<!-- <div *ngIf="article$ | async as article">
    <article-form-feature *ngIf="article != undefined" [article]="article" (articleSubmit)="onSubmit($event)">
    </article-form-feature>
</div> -->

<section class="overview" *ngIf="article$ | async as article">
    <article-form-feature *ngIf="article != undefined" [article]="article" (articleSubmit)="onSubmit($event)">
    </article-form-feature>
</section>